import i18n from '@/i18n';
// Типи відповідей ендпоінтів модуля «Фінансовий результат» (етап 3 бекенда).

export interface Station { assetId: string; assetName: string; wCode: string | null }

export interface DayHour {
  hour: number;
  planMwh: number | null;
  priceUahMwh: number | null;
  priceModel: string | null;
  plannedIncomeUah: number | null;
  deliveredMwh: number | null;
  hasDelivery: boolean;
  imbalanceMwh: number | null;
  operSettlementUah: number | null;
  factSettlementUah: number | null;
  actualImbalanceKwh: number | null;
  actualPriceUahMwh: number | null;
  actualSettlementUah: number | null;
}

export interface DaySummary {
  planMwh: number | null;
  plannedIncomeUah: number | null;
  hasDelivery: boolean;
  deliveredMwh: number | null;
  imbalanceMwh: number | null;
  operImbalanceUah: number | null;
  factImbalanceUah: number | null;
  actualImbalanceMwh: number | null;
  actualSettlementUah: number | null;
  actualHours: number;
  resultPlannedUah: number | null;
  resultOperationalUah: number | null;
  resultRefinedUah: number | null;
  refinedIsFinal: boolean;
  actualVsMarketDeltaUah: number | null;
}

export interface DayPayload {
  assetId: string;
  date: string;
  assetName: string;
  wCode: string | null;
  hours: DayHour[];
  summary: DaySummary | null;
}

export interface MonthDay {
  day: string;
  planMwh: number | null;
  plannedIncomeUah: number | null;
  deliveredMwh: number | null;
  imbalanceMwh: number | null;
  resultPlannedUah: number | null;
  resultOperationalUah: number | null;
  resultRefinedUah: number | null;
  refinedIsFinal: boolean;
}

export interface MonthTotals {
  plannedIncomeUah: number | null;
  planMwh: number | null;
  deliveredMwh: number | null;
  imbalanceMwh: number | null;
  resultOperationalUah: number | null;
  resultRefinedUah: number | null;
  allFinal: boolean;
}

export interface MonthPayload {
  assetId: string;
  month: string;
  days: MonthDay[];
  totals: MonthTotals | null;
}

// ── формат ──────────────────────────────────────────────────────────────
const nf = (min: number, max: number) =>
  new Intl.NumberFormat((i18n.language === 'en' ? 'en-GB' : 'uk-UA'), { minimumFractionDigits: min, maximumFractionDigits: max });

export const fmtUah = (v: number | null | undefined, dash = '—') =>
  v == null || Number.isNaN(v) ? dash : nf(0, 0).format(Math.round(v)) + ' ' + i18n.t('ak_fin_uah');
export const fmtUah2 = (v: number | null | undefined, dash = '—') =>
  v == null || Number.isNaN(v) ? dash : nf(2, 2).format(v) + ' ' + i18n.t('ak_fin_uah');
export const fmtMwh = (v: number | null | undefined, dash = '—') =>
  v == null || Number.isNaN(v) ? dash : nf(3, 3).format(v);
export const fmtPrice = (v: number | null | undefined, dash = '—') =>
  v == null || Number.isNaN(v) ? dash : nf(2, 2).format(v);
export const fmtSignMwh = (v: number | null | undefined, dash = '—') =>
  v == null || Number.isNaN(v) ? dash : (v >= 0 ? '+' : '−') + nf(3, 3).format(Math.abs(v));
